const mutation = {

  POD_LOADING(state, status) {
    state.isLoading = status;
  },

  UPDATE_TRACK_DATA(state, data) {
    state.consigneeTrack = data;
  },

  SET_LOCATION_DATA(state, data) {
    state.locationData = data;
  },

};

export default mutation;
